import React, { useState } from 'react';
import { Phone, Download, Calendar } from 'lucide-react';
import SiteVisitPopup from '../SiteVisitPopup';
import { FaWhatsapp } from 'react-icons/fa';

const TabNavigation = () => {
  // const [activeTab, setActiveTab] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // const tabs = [
  //   { name: "Location", id: "location" },
  //   { name: "Lifestyle", id: "lifestyle" },
  //   { name: "Floor Plans", id: "floorplans" },
  //   // { name: "Housing", id: "housing" },
  //   { name: "Amenities", id: "amenities" },
  //   { name: "Services", id: "services" }
  // ];

  // const handleTabClick = (index, id) => {
  //   setActiveTab(index);
  //   const element = document.getElementById(id);
  //   if (element) {
  //     const navbarHeight = 64; // Height of your navbar
  //     const tabHeight = 48; // Height of tabs section
  //     const totalOffset = navbarHeight + tabHeight; // Reduced from 20px to 10px padding
  //     const elementPosition = element.offsetTop - totalOffset;
  //     window.scrollTo({
  //       top: elementPosition,
  //       behavior: 'smooth'
  //     });
  //   }
  // };

  const handleBookSiteVisit = () => {
    setIsPopupOpen(true);
  };

  const handleDownloadBrochure = () => {
    // Add brochure download logic here
    const link = document.createElement('a');
    link.href = '/brochure.pdf';
    link.download = 'Dignity-Retirement-Brochure.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleWhatsApp = () => {
    const message = "Hello, I'm interested in learning more about Dignity.";
    const url = `https://wa.me/918590442525?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  const handleCall = () => {
    window.location.href = 'tel:+918590442525';
  };

  // Update active tab based on scroll position
  // useEffect(() => {
  //   const handleScroll = () => {
  //     const sections = tabs.map(tab => document.getElementById(tab.id));
  //     const navbarHeight = 64;
  //     const tabHeight = 56;
  //     const scrollPosition = window.scrollY + navbarHeight + tabHeight + 30; 

  //     let currentActive = 0;
      
  //     sections.forEach((section, index) => {
  //       if (section) {
  //         const sectionTop = section.offsetTop;
  //         const sectionBottom = sectionTop + section.offsetHeight;

  //         if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
  //           currentActive = index;
  //         }
  //       }
  //     });

  //     setActiveTab(currentActive);
  //   };

  //   window.addEventListener('scroll', handleScroll, { passive: true });
  //   return () => window.removeEventListener('scroll', handleScroll);
  // }, []);

  return (
    <>
      {/* Tabs Section - Fixed */}
      {/* <div className="bg-white sticky top-16 z-40 ">
        <div className="max-w-7xl mx-auto">
          <div className="flex overflow-x-auto scrollbar-hide">
            {tabs.map((tab, index) => (
              <button
                key={tab.id}
                onClick={() => handleTabClick(index, tab.id)}
                className={`flex-shrink-0 px-6 py-4 border-b-2 font-medium text-sm transition-all duration-200 whitespace-nowrap ${
                  activeTab === index
                    ? 'border-[var(--primarycolor)] text-[var(--primarycolor)]'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                {tab.name}
              </button>
            ))}
          </div>
        </div>
      </div> */}

      {/* Action Buttons Section - Scrolls normally */}
      <div className="">
        <div className="max-w-7xl mx-auto px-3 sm:px-6 pt-10">
          <div className="grid grid-cols-2 md:grid-cols-4 items-center gap-3">
            <button
              onClick={handleBookSiteVisit}
              className="flex items-center gap-2 border-[var(--primarycolor)] bg-white border-2 text-[var(--primarycolor)] px-5 py-3.5 rounded-lg font-semibold transition-all duration-200 text-sm justify-center shadow-sm hover:shadow-md"
            >
              <Calendar className="w-4 h-4" />
              Book Visit
            </button>
            
            <button
              onClick={handleDownloadBrochure}
              className="flex items-center gap-2 bg-white text-black border-2 border-black px-5 py-3.5 rounded-lg font-semibold transition-all duration-200 text-sm justify-center shadow-sm hover:shadow-md "
            >
              <Download className="w-4 h-4" />
              Brochure
            </button>

            <button
              onClick={handleWhatsApp}
              className="flex items-center gap-2 bg-white hover:bg-gray-50 text-green-600 border-2 border-green-600 px-5 py-3.5 rounded-lg font-semibold transition-all duration-200 text-sm justify-center shadow-sm hover:shadow-md"
            >
              <FaWhatsapp className="w-5 h-5 text-green-600" />
              WhatsApp
            </button>

            <button
              onClick={handleCall}
              className="flex items-center gap-2 bg-white text-blue-500 border-2 border-blue-500 px-5 py-3.5 rounded-lg font-semibold transition-all duration-200 text-sm justify-center shadow-sm hover:shadow-md "
            >
              <Phone className="w-4 h-4 " />
              Call Now
            </button>
          </div>
        </div>
      </div>


      <SiteVisitPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </>
  );
};

export default TabNavigation;